module.exports = __webpack_public_path__ + "img/Portada.22544421.png";